import { createContext } from "react";

const userDataContext = createContext({
  user: null,
  loginWithGoogle: () => {},
  logout: () => {},
});

export default userDataContext;